import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { TemplateCategory } from './types/template-category.type';

/**
 * Inserts a new template category by sending a POST request to the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param data - The template category data to be inserted.
 * @returns A promise that resolves to the operation result of the insertion.
 * @throws Will throw an error if the request fails.
 */
export const insertTemplateCategory = async (instance: KyInstance, data: TemplateCategory) => {
  try {
    return await instance.post<OperationResult>(Uri.template.insertTemplateCategory, { json: data }).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
